function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "currentColor",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M18,15 L15,18 L15,16 L14.338,16 C13.166,16 12.078,15.418 11.427,14.441 L13.09,13.332 C13.369,13.75 13.836,14 14.338,14 L15,14 L15,12 L15,10 L14.338,10 C13.836,10 13.369,10.25 13.09,10.668 L10.574,14.441 C9.923,15.418 8.834,16 7.662,16 L6,16 L6,14 L7.662,14 C8.164,14 8.631,13.75 8.91,13.332 L11.426,9.559 C12.078,8.582 13.166,8 14.338,8 L15,8 L15,6 L18,9 L15,12 L18,15 Z M6,8 L7.662,8 C8.834,8 9.923,8.582 10.574,9.558 L8.91,10.668 C8.631,10.25 8.164,10 7.662,10 L6,10 L6,8 Z M12,2 C6.478,2 2,6.477 2,12 C2,17.522 6.478,22 12,22 C17.522,22 22,17.522 22,12 C22,6.477 17.522,2 12,2 L12,2 Z",
  fill: "currentColor"
}));

var SvgIconRandom = function SvgIconRandom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 30",
    x: "0px",
    y: "0px",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconRandom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-random.9ed682df.svg";
export { ForwardRef as ReactComponent };